import React from "react";
import i18next from "i18next";

export const FixButton = ({isVisible, onClick}) => {

  if (!isVisible) {
    return null;
  }

  return (
    <button type="button" className={"btn btn-primary btn-sm rounded-pill c-pointer"}
            style={{ background: '#659ec8', color: '#fff' }} onClick={onClick}>{i18next.t('Coordinate')}
       <i className="zmdi zmdi-email" style={{fontSize: '16px'}}></i>
    </button>
  );

}